module.exports = __webpack_public_path__ + "img/login-bg.cb843dad.png";